import styled from 'styled-components';
import PropTypes from 'prop-types';
import breakpoints from './breakpoints';
import sharedStyles from './styles';

const ProductCardGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  grid-gap: ${sharedStyles.spacing['spacing-md']};
  padding: ${({ padding }) => padding};
  justify-items: center;
  margin: ${sharedStyles.spacing['spacing-md']} 0;
  @media screen and (min-width: 400px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media screen and (min-width: ${breakpoints.lg}) {
    grid-template-columns: repeat(3, 1fr);
  }
  @media screen and (min-width: ${breakpoints.xl}) {
    grid-template-columns: repeat(4, 1fr);
  }
`;

ProductCardGrid.propTypes = {
  padding: PropTypes.string,
};

ProductCardGrid.defaultProps = {
  padding: `${sharedStyles.spacing['spacing-1xl']} ${sharedStyles.spacing['spacing-lg']}`,
};

export default ProductCardGrid;
